import React, { Component } from 'react';
import {
    Box,
    Typography,
    TextField,
    Grid,
    MenuItem,
    InputAdornment,
    Avatar,
    Button
} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import MusicNoteIcon from '@mui/icons-material/MusicNote'; // Para TikTok
import YouTubeIcon from '@mui/icons-material/YouTube';
import LanguageIcon from '@mui/icons-material/Language';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { toast } from 'react-toastify';





class ContactSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            whatsapp: '',
            telefone: '',
            email: '',

        };
    }

    componentDidMount() {
        var { whatsapp, telefone, email } = this.props.data;
        this.setState({ whatsapp, telefone, email });

    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const inputStyle = {
            '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                backgroundColor: '#f8f9fa',
                '& fieldset': { borderColor: '#e0e0e0' },
            }
        };

        const socialIconStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: '8px',
            bgcolor: '#f5f5f5',
            color: '#757575',
            mr: 1
        };

        return (
            <Box sx={{ p: 0, margin: '0 auto' }}>


                {/* WhatsApp e Telefone Fixo */}
                <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item size={{ xs: 12, md: 3 }}>


                        <TextField
                            label="WhatsApp"
                            fullWidth
                            name="whatsapp"
                            placeholder="(11) 99999-9999"
                            sx={inputStyle}
                            size="small"
                            value={this.state.whatsapp}
                            onChange={this.handleChange}
                        />


                    </Grid>

                    <Grid item size={{ xs: 12, md: 3 }}>
                        <Box sx={{ display: 'flex', gap: 1 }}>

                            <TextField
                                label="Telefone"
                                fullWidth
                                name="telefone"
                                placeholder="(11) 3333-3333"
                                sx={inputStyle}
                                size="small"
                                value={this.state.telefone}
                                onChange={this.handleChange}
                            />
                        </Box>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 3 }}>

                        <TextField
                            label="E-mail"
                            type="email"
                            fullWidth
                            name="email"
                            value={this.state.email}
                            sx={inputStyle}
                            size="small"
                            onChange={this.handleChange}
                        />
                    </Grid>

                </Grid>




                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        mt: 4,
                        pt: 2,
                        borderTop: '1px solid #eee'
                    }}
                >


                    <Button

                        variant="contained"
                        onClick={() => {
                            fetch(`${process.env.REACT_APP_API_URL}/settings/contact`, {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    whatsapp: this.state.whatsapp,
                                    telefone: this.state.telefone,
                                    email: this.state.email
                                }),
                            })
                                .then(response => {
                                    if (response.ok) {
                                        toast.success('Endereço atualizado com sucesso!');
                                    } else {
                                        toast.error('Erro ao atualizar o endereço.');
                                    }
                                })
                                .catch(error => {
                                    console.error('Erro ao atualizar o endereço:', error);
                                });
                        }}
                        startIcon={<SaveOutlinedIcon />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            bgcolor: '#6200ee',
                            px: 4,
                            '&:hover': { bgcolor: '#4a00b8' }
                        }}
                    >
                        Salvar Endereço
                    </Button>
                </Box>
            </Box>
        );
    }
}

export default ContactSettings;